// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/fonts/MontserratAlternates-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/fonts/MontserratAlternates-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/fonts/Raleway-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/fonts/Raleway-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/fonts/Raleway-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/fonts/Raleway-Medium.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: 'Montserrat Alternates';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('ttf'),
		url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
	font-weight: 600;
	font-style: normal;
}
@font-face {
	font-family: 'Raleway';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('ttf'),
		url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
	font-weight: 400;
	font-style: normal;
}
@font-face {
	font-family: 'Raleway';
	src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('ttf'),
		url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
	font-weight: 500;
	font-style: normal;
}

* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

:root {
	--font-montserrat: 'Montserrat Alternates';
	--font-raleway: 'Raleway';

	--white: #fff;
	--blue-dark: #01142e;
	--blue: #253fa7;
	--red: #ca263f;
	--red-2: #d23b48;
	--grey: #8e8e8e;
	--grey-2: #e6e6e6;
	--green: #3bd252;

	--gradient-blue: linear-gradient(90deg, #3885b1 0%, #26518b 100%);
	--gradient-red: linear-gradient(90deg, #e66b5b 0%, #ca263f 100%);

	--shadow-blue: 0px 4px 0px 0px #19355d;
	--shadow-red: 0px 4px 0px 0px #6a1623;
	--shadow-blue-red: 0px 4px 0px 0px #19355d, 0px 4px 24px 0px #ca263f;
	--shadow-red-red: 0px 4px 0px 0px #6a1623, 0px 4px 24px 0px #ca263f;
	--shadow-menu: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
	--shadow-card: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);
	--fill-blue-light: #12eff7;

	/* --gray-50: #F6F8FF;
  --gray-100: #697C9A;
  --gray-200: #4B6A9B;
  --gray-300: #2B3442;
  --gray-400: #1E2A47;
  --gray-500: #141D2F;

  --error-color: #F74646;

  --shadow: 0px 16px 30px -10px rgba(70, 96, 187, 0.198567);  */
}
html {
	font-size: 10px;
}

body {
	font-size: 1.8rem;
	font-family: 'Raleway', monospace;
	font-weight: 400;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: var(--blue-dark);
	background: #fbfbfb;
}

a {
	text-decoration: none;
	font-family: 'Raleway', monospace;
}
button {
	border-style: none;
	background: transparent;
	font-size: 1.8rem;

	&:hover {
		cursor: pointer;
	}
}
input {
	font-size: 1.6rem;

	&:focus-visible {
		outline: none;
	}
}

@media (max-width: 1400px) {
	html {
		font-size: 8px;
	}
}

/* mobile */
@media (max-width: 800px) {
	html {
		font-size: 10px;
	}
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;CACC,oCAAoC;CACpC;wDACkE;CAClE,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,sBAAsB;CACtB;wDACoD;CACpD,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,sBAAsB;CACtB;wDACmD;CACnD,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,SAAS;CACT,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,0CAA0C;CAC1C,yBAAyB;;CAEzB,aAAa;CACb,oBAAoB;CACpB,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;;CAEhB,iEAAiE;CACjE,gEAAgE;;CAEhE,sCAAsC;CACtC,qCAAqC;CACrC,oEAAoE;CACpE,mEAAmE;CACnE,kDAAkD;CAClD,kDAAkD;CAClD,0BAA0B;;CAE1B;;;;;;;;;+DAS8D;AAC/D;AACA;CACC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,iCAAiC;CACjC,gBAAgB;CAChB,mCAAmC;CACnC,kCAAkC;CAClC,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,iCAAiC;AAClC;AACA;CACC,kBAAkB;CAClB,uBAAuB;CACvB,iBAAiB;;CAEjB;EACC,eAAe;CAChB;AACD;AACA;CACC,iBAAiB;;CAEjB;EACC,aAAa;CACd;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA,WAAW;AACX;CACC;EACC,eAAe;CAChB;AACD","sourcesContent":["@font-face {\n\tfont-family: 'Montserrat Alternates';\n\tsrc: url(/src/fonts/MontserratAlternates-SemiBold.ttf) format('ttf'),\n\t\turl(/src/fonts/MontserratAlternates-SemiBold.woff) format('woff');\n\tfont-weight: 600;\n\tfont-style: normal;\n}\n@font-face {\n\tfont-family: 'Raleway';\n\tsrc: url(/src/fonts/Raleway-Regular.ttf) format('ttf'),\n\t\turl(/src/fonts/Raleway-Regular.woff) format('woff');\n\tfont-weight: 400;\n\tfont-style: normal;\n}\n@font-face {\n\tfont-family: 'Raleway';\n\tsrc: url(/src/fonts/Raleway-Medium.ttf) format('ttf'),\n\t\turl(/src/fonts/Raleway-Medium.woff) format('woff');\n\tfont-weight: 500;\n\tfont-style: normal;\n}\n\n* {\n\tmargin: 0;\n\tpadding: 0;\n\tbox-sizing: border-box;\n}\n\n:root {\n\t--font-montserrat: 'Montserrat Alternates';\n\t--font-raleway: 'Raleway';\n\n\t--white: #fff;\n\t--blue-dark: #01142e;\n\t--blue: #253fa7;\n\t--red: #ca263f;\n\t--red-2: #d23b48;\n\t--grey: #8e8e8e;\n\t--grey-2: #e6e6e6;\n\t--green: #3bd252;\n\n\t--gradient-blue: linear-gradient(90deg, #3885b1 0%, #26518b 100%);\n\t--gradient-red: linear-gradient(90deg, #e66b5b 0%, #ca263f 100%);\n\n\t--shadow-blue: 0px 4px 0px 0px #19355d;\n\t--shadow-red: 0px 4px 0px 0px #6a1623;\n\t--shadow-blue-red: 0px 4px 0px 0px #19355d, 0px 4px 24px 0px #ca263f;\n\t--shadow-red-red: 0px 4px 0px 0px #6a1623, 0px 4px 24px 0px #ca263f;\n\t--shadow-menu: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);\n\t--shadow-card: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);\n\t--fill-blue-light: #12eff7;\n\n\t/* --gray-50: #F6F8FF;\n  --gray-100: #697C9A;\n  --gray-200: #4B6A9B;\n  --gray-300: #2B3442;\n  --gray-400: #1E2A47;\n  --gray-500: #141D2F;\n\n  --error-color: #F74646;\n\n  --shadow: 0px 16px 30px -10px rgba(70, 96, 187, 0.198567);  */\n}\nhtml {\n\tfont-size: 10px;\n}\n\nbody {\n\tfont-size: 1.8rem;\n\tfont-family: 'Raleway', monospace;\n\tfont-weight: 400;\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n\tcolor: var(--blue-dark);\n\tbackground: #fbfbfb;\n}\n\na {\n\ttext-decoration: none;\n\tfont-family: 'Raleway', monospace;\n}\nbutton {\n\tborder-style: none;\n\tbackground: transparent;\n\tfont-size: 1.8rem;\n\n\t&:hover {\n\t\tcursor: pointer;\n\t}\n}\ninput {\n\tfont-size: 1.6rem;\n\n\t&:focus-visible {\n\t\toutline: none;\n\t}\n}\n\n@media (max-width: 1400px) {\n\thtml {\n\t\tfont-size: 8px;\n\t}\n}\n\n/* mobile */\n@media (max-width: 800px) {\n\thtml {\n\t\tfont-size: 10px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
